import * as React from 'react';
import { WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';
import { RouteProps } from 'react-router-dom';
import { observer } from 'mobx-react';
import styles from './Public.styles';
import Public from '@shared/modules/Public';
import ROUTES from '@Admin/shared/constants/routes';
const Signout = React.lazy(() => import('../Private/submodules/Signout'));

const Loading = React.lazy(() => import('@shared/components/Loading'));

interface PublicProps extends WithStyles<typeof styles> { }

@observer
class PublicModule extends React.Component<PublicProps> {
  get routes(): Array<RouteProps> {
    const { notFound, signoutOidc } = ROUTES.public;

    return [
      { path: notFound, element: <Loading /> },
      { path: signoutOidc, element: <Signout /> },
    ];
  }

  render() {
    return <Public routes={this.routes} {...this.props} />;
  }
}

export default withStyles(styles)(PublicModule);
